import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';
import { AdvisorProFreeWillsLimit } from '@/modules/financialadvisor/constants/AdvisorProFreeWillsLimit';

export class FinancialAdvisorFaqItem extends Enum {
  key!: string;
  question!: () => string;
  answer!: (price?: string) => string;
  open!: boolean;

  static ANNUAL_PLAN_BILLING: FinancialAdvisorFaqItem = {
    key: 'annual_plan_billing',
    question: () => Lang.t('financialadvisor.pro-upsell-faq-billing-question'),
    answer: (price?: string) => Lang.t('financialadvisor.pro-upsell-faq-billing-answer', { price })
  };

  static MONTHLY_PLAN: FinancialAdvisorFaqItem = {
    key: 'monthly_plan',
    question: () => Lang.t('financialadvisor.pro-upsell-faq-monthly-plan-question'),
    answer: () =>
      Lang.t('financialadvisor.pro-upsell-faq-monthly-plan-answer', {
        count: AdvisorProFreeWillsLimit.MONTHLY_PLAN_LIMIT,
        freeYearlyWillsLimit: AdvisorProFreeWillsLimit.ANNUAL_PLAN_LIMIT
      })
  };

  static AUTO_RENEW: FinancialAdvisorFaqItem = {
    key: 'auto_renew',
    question: () => Lang.t('financialadvisor.pro-upsell-faq-auto-renew-question'),
    answer: () => Lang.t('financialadvisor.pro-upsell-faq-auto-renew-answer')
  };

  static GUARANTEE: FinancialAdvisorFaqItem = {
    key: 'guarantee',
    question: () => Lang.t('financialadvisor.pro-upsell-faq-guarantee-question'),
    answer: () => Lang.t('financialadvisor.guarantee-how-it-works')
  };

  static REFUND_VS_AUTO_RENEW: FinancialAdvisorFaqItem = {
    key: 'refund_vs_auto_renew',
    question: () => Lang.t('financialadvisor.pro-upsell-faq-refund-vs-auto-renew-question'),
    answer: () => Lang.t('financialadvisor.guarantee-refund-vs-auto-renew')
  };

  static REFUND_REQUEST: FinancialAdvisorFaqItem = {
    key: 'refund_request',
    question: () => Lang.t('financialadvisor.pro-upsell-faq-refund-request-question'),
    answer: () => Lang.t('financialadvisor.guarantee-how-to-request')
  };
}
